var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',{staticClass:"setting-content",attrs:{"span":24}},[_c('long-tail-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }